import { FeeComponentProps } from '../../types';
import { useDataContext } from '../../context/dataContainer';
import { ClientFee } from './ClientFee';
import { PayPageFee } from './PayPageFee';

export { ClientFee } from './ClientFee';
export { PayPageFee } from './PayPageFee';

export const FeeInfo = (props: FeeComponentProps) => {
  const { feesDisclaimers, clientFeesDisclaimers } = useDataContext();

  if (feesDisclaimers.length) {
    return <PayPageFee paymentType={props.paymentType} currentLanguage={props.currentLanguage} />;
  }

  if (clientFeesDisclaimers.length) {
    return <ClientFee {...props} />;
  }

  return null;
};
